var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndexImg04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 100,
    viewBox: "0 0 120 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1990 -1708)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 100,
    transform: "translate(-1990 1708)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2781.052 -73.505)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.98,91.771H27.373a1.907,1.907,0,0,1,0-3.814H32.98a1.907,1.907,0,1,1,0,3.814",
    transform: "translate(820.094 1782.505)",
    fill: "#00aeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.183,66.5a1.42,1.42,0,0,1-.53-.1,1.4,1.4,0,0,1-.871-1.3V31.082a1.4,1.4,0,0,1,1.4-1.4H70.5a1.4,1.4,0,0,1,1.4,1.4V56.863a1.4,1.4,0,0,1-1.4,1.4H41.843l-7.66,7.816a1.4,1.4,0,0,1-1,.42m1.4-34.018V61.67l5.671-5.787a1.4,1.4,0,0,1,1-.42H69.1V32.482Z",
    transform: "translate(820.156 1782.505)",
    fill: "#ede100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.764,40.636H41.913a1.4,1.4,0,0,1,0-2.8H61.764a1.4,1.4,0,0,1,0,2.8",
    transform: "translate(820.156 1782.505)",
    fill: "#ffec00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.88,50.108H41.913a1.4,1.4,0,1,1,0-2.8H51.88a1.4,1.4,0,0,1,0,2.8",
    transform: "translate(820.123 1782.505)",
    fill: "#ffec00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4,0H9.707A9.7,9.7,0,0,0,0,9.69V88.31A9.7,9.7,0,0,0,9.707,98H51.4A9.7,9.7,0,0,0,61.1,88.31V61.26H58.1V88.31A6.7,6.7,0,0,1,51.4,95H9.707a6.7,6.7,0,0,1-6.7-6.69V9.69A6.7,6.7,0,0,1,9.707,3H51.4a6.7,6.7,0,0,1,6.7,6.69V26.68H61.1V9.69A9.7,9.7,0,0,0,51.4,0",
    transform: "translate(820.052 1782.505)",
    fill: "#00aeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5,1.5h-60v-3h60Z",
    transform: "translate(822.052 1797.505)",
    fill: "#00aeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5,1.5h-60v-3h60Z",
    transform: "translate(822.052 1865.505)",
    fill: "#00aeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.183,66.5a1.42,1.42,0,0,1-.53-.1,1.4,1.4,0,0,1-.871-1.3V31.082a1.4,1.4,0,0,1,1.4-1.4H70.5a1.4,1.4,0,0,1,1.4,1.4V56.863a1.4,1.4,0,0,1-1.4,1.4H41.843l-7.66,7.816a1.4,1.4,0,0,1-1,.42m1.4-34.018V61.67l5.671-5.787a1.4,1.4,0,0,1,1-.42H69.1V32.482Z",
    transform: "translate(820.156 1782.505)",
    fill: "#ffec00"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 98,
    transform: "translate(820.052 1782.505)",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndexImg04);
export default __webpack_public_path__ + "static/media/index-img-04.e6fc1dd1e8a519697f0b82a7821380c5.svg";
export { ForwardRef as ReactComponent };